import React, { Component } from "react";
import Service from "../../../Service/Service";
import BlendingLogo from "../../../Graphics/BlendingLogo";
import equipment from "../../../../../media/reduced-images/equipment.jpg";

class Blending extends Component {
  render() {
    return (
      <Service
        title="Blending"
        logo={<BlendingLogo />}
        image={equipment}
        description="We offer batch and continuous blending depending on the application."
      />
    );
  }
}

export default Blending;
